<template>
  <div>
    <p
      v-if="bothLocksON"
      :class="[
        caps_num_lock,
        addAlignment ? 'caps_num_lock_alignment' : 'caps_num_lock',
      ]"
    >
      <span class="cap_warning_icon">
        <img
          src="@/common/assets/styles/corp/images/caps_warning.png"
          alt="caps_lock_warning_icon"
        />
      </span>
      <span> Caps & Num Lock is On </span>
    </p>
    <p
      v-else-if="capsLockON"
      :class="[
        caps_num_lock,
        addAlignment ? 'caps_num_lock_alignment' : 'caps_num_lock',
      ]"
    >
      <span class="cap_warning_icon">
        <img
          src="@/common/assets/styles/corp/images/caps_warning.png"
          alt="caps_lock_warning_icon"
        />
      </span>
      <span> Caps Lock On </span>
    </p>
    <p
      v-else-if="numsLockON"
      :class="[
        caps_num_lock,
        addAlignment ? 'caps_num_lock_alignment' : 'caps_num_lock',
      ]"
    >
      <span class="cap_warning_icon">
        <img
          src="@/common/assets/styles/corp/images/caps_warning.png"
          alt="caps_lock_warning_icon"
        />
      </span>
      <span> Num Lock On </span>
    </p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "CapsLockError",
  props: {
    addAlignment: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("login", ["capsLockON", "numsLockON", "bothLocksON"]),
  },
};
</script>
<style></style>
